import { config } from '@/config';
import React from 'react';
import { useEffect } from 'react';

const HubspotInjector = () => {
  useEffect(() => {
    const id = config.hubspotId;
    if (!id) return;

    // Check if the HubSpot script is already loaded
    let hubspotScript = document.getElementById('hubspot-script');
    if (hubspotScript) return;

    const script = document.createElement('script');
    script.src = `https://js.hs-scripts.com/${id}.js`;
    script.id = 'hubspot-script';
    script.async = true;
    script.defer = true;

    // Add functionality for after script loads
    script.onload = () => {
      setTimeout(() => {
        // Look for pusher element
        const pusher = document.querySelector('#hs-web-interactives-top-push-anchor');
        if (!pusher) return;

        // Add click to remove the element
        pusher.addEventListener('click', () => {
          pusher.remove();
          console.log('HubSpot pusher removed');
        });
      }, 1000);
    };

    document.body.appendChild(script);

    console.log('HubSpot script injected');
  }, []);

  return <></>;
};

export default HubspotInjector;
